import { useTranslation } from 'react-i18next'
import type { LevelOption } from '../types'

/**
 * Stratejik Hedef ve Katkı (127) — <b>salt-okuma</b> gösterim: adlar parametre ekranındaki sırayla, virgülle;
 * seçim yoksa "—". "Ana Görevi Gör", Toplantı Yönetimi görev detayı ve Yeniden Açma pencereleri
 * ({@code MainTaskDetailView}) bunu kullanır — orada girdiler devre dışı kutu değil düz metindir.
 */
export default function TaskClassificationView({
  strategicObjectives,
  contributions,
}: Readonly<{ strategicObjectives?: LevelOption[]; contributions?: LevelOption[] }>) {
  const { t } = useTranslation()
  return (
    <>
      <div className="act-field">
        <span className="ui-field-label">{t('actions.classification.strategicObjectives')}</span>
        <p className="act-readonly-text">{joinNames(strategicObjectives)}</p>
      </div>
      <div className="act-field">
        <span className="ui-field-label">{t('actions.classification.contributions')}</span>
        <p className="act-readonly-text">{joinNames(contributions)}</p>
      </div>
    </>
  )
}

function joinNames(items: LevelOption[] | undefined): string {
  return items && items.length > 0 ? items.map((o) => o.name).join(', ') : '—'
}
